import React, { useState, useEffect } from 'react';
import { ShowCitizensDialogComponent } from './show-citizens-dialog-component';
import { CitizenDto } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

export interface IShowCitizensDialogProps {
  citizenIds: string[];
}
export interface ICitizen extends CitizenDto {
  id: string;
}
export function ShowCitizensDialog({ citizenIds }: IShowCitizensDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [citizens, setCitizens] = useState<ICitizen[]>([]);

  useEffect(() => {
    async function init() {
      try {
        setIsLoading(true);
        const citizenClient = moduleClientFactory.createCitizenClient();
        const result = await citizenClient.getByIds({ citizenIds });
        setCitizens((result?.citizens as ICitizen[]) || []);
      } finally {
        setIsLoading(false);
      }
    }
    init();
  }, []);
  function handleClose() {
    setIsOpen(false);
  }
  return <ShowCitizensDialogComponent isLoading={isLoading} open={isOpen} citizens={citizens} onClose={handleClose} />;
}
